import { APPLICATION_CODE_ROUTES } from '@/constants';

export function getApplicationLaunchRoute(
  applicationCode: string,
  nativeApplication: boolean,
  state?: string
) {
  if (nativeApplication) {
    return APPLICATION_CODE_ROUTES[applicationCode] ?? '#';
  }
  const stateQueryParam = state ? `?state=${state}` : '';
  return `/api/auth/v2/launch/route/app/${applicationCode}${stateQueryParam}`;
}
